import SelectInput from 'components/common/Inputs/SelectInput'
import React, { useEffect, useState } from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { SelectContainer, StyledTextArea } from 'routes/App/Apps/MyJobs/styles'
import messages from 'routes/App/Apps/MyJobs/translate'
import { DELETION_REASON_FIELDS } from 'routes/App/JobsAdmin/Jobs/JobWorkflowForm/constants'
import { DeletionReasonFieldProps } from './Common.types'

export const DeletionReasonField = ({
  intl: { formatMessage },
  onChangeDeletionReasonFieldValue,
  deletionReasons,
  deletionReasonType,
}: DeletionReasonFieldProps & WrappedComponentProps) => {
  const [deletionReasonFieldValue, setDeletionReasonFieldValue] = useState(
    {} as {
      lookup: string
      text: string
    },
  )

  useEffect(() => () => onChangeDeletionReasonFieldValue(null), [])

  const onChangeDeletionReason = ({
    target: { value },
  }: React.ChangeEvent<{ value: string }>): void => {
    setDeletionReasonFieldValue({
      ...deletionReasonFieldValue,
      text: value,
    })
    onChangeDeletionReasonFieldValue({
      ...deletionReasonFieldValue,
      text: value,
    })
  }

  return (
    <>
      {(deletionReasonType === DELETION_REASON_FIELDS.LOOKUP ||
        deletionReasonType === DELETION_REASON_FIELDS.LOOKUP_AND_TEXTAREA) && (
        <SelectContainer>
          <SelectInput
            options={deletionReasons?.map(reason => ({
              label: reason,
              value: reason,
            }))}
            required
            label={formatMessage(messages.reasonForDeletion)}
            onChange={(value: string) => {
              setDeletionReasonFieldValue({
                ...deletionReasonFieldValue,
                lookup: value,
              })
              onChangeDeletionReasonFieldValue({
                ...deletionReasonFieldValue,
                lookup: value,
              })
            }}
            value={deletionReasonFieldValue.lookup || ''}
          />
        </SelectContainer>
      )}
      {(deletionReasonType === DELETION_REASON_FIELDS.TEXTAREA ||
        deletionReasonType === DELETION_REASON_FIELDS.LOOKUP_AND_TEXTAREA) && (
        <StyledTextArea
          fullWidth
          required
          multiline
          value={deletionReasonFieldValue.text || ''}
          onChange={onChangeDeletionReason}
          label={formatMessage(messages.reasonForDeletion)}
        />
      )}
    </>
  )
}

export default injectIntl(DeletionReasonField)
